module.exports = __webpack_public_path__ + "img/Group.da98b0dc.svg";